// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Campaign20CircleFilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Campaign20CircleFilled: FC<Campaign20CircleFilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="24"
        >
            <path
                d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Zm8-12.75h-3v1.5h3v-1.5Zm-4.604 5.542 2.458 1.708.875-1.23-2.458-1.707-.875 1.229Zm0-9.584.854 1.23 2.458-1.709-.854-1.229-2.458 1.708ZM6 14v4h2v-4h.52L13 16.75v-9.5L8.396 10H5.5c-.417 0-.77.146-1.063.438A1.447 1.447 0 0 0 4 11.5v1c0 .417.146.77.438 1.063.291.291.645.437 1.062.437H6Zm8.74-3.333A3.121 3.121 0 0 0 14 9.563v4.874a3.12 3.12 0 0 0 .74-1.104 3.534 3.534 0 0 0 0-2.666Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default Campaign20CircleFilled;
